import { getTokenValue, View, XStack, YStack } from 'tamagui';
import PSText from './ui/PSText';
import { letterSpacing } from '@/constants/tokens';

/**
 * TimeSelector — a single selectable time-slot chip (molecule).
 *
 * The content-hugging time button from the event page's time picker. Same
 * selected flip as DateSelector but pill-shaped around a single label; kept as
 * its own molecule (no shared chip atom) since RN text doesn't cascade and the
 * two differ in shape + content.
 *   unselected: transparent fill · gray border · black text
 *   selected:   black fill · black border · light text
 * Border stays a constant hairline (only its color flips) so the chip never
 * changes size between states.
 */
type TimeSelectorProps = {
  label: string; // e.g. "10:30 AM"
  selected: boolean;
  onPress?: () => void;
  hasApTickets: boolean;
};

export default function TimeSelector({
  label,
  selected,
  onPress,
  hasApTickets,
}: TimeSelectorProps) {
  const fg = selected ? '$background' : '$color';

  return (
    <YStack>
      <View
        onPress={onPress}
        cursor={onPress ? 'pointer' : undefined}
        rounded="$base"
        px="$lg"
        py="$sm"
        borderWidth="$borderWidth.hairline"
        borderColor={selected ? '$color' : '$borderColor'}
        backgroundColor={selected ? '$color' : '$transparent'}
        borderBottomLeftRadius={hasApTickets ? 0 : '$radius.base'}
      >
        <PSText.Body2 color={fg}>{label}</PSText.Body2>
      </View>
      {hasApTickets && (
        <XStack
          backgroundColor={'$color.brand'}
          px={'$space.sm'}
          py={'$space.xs'}
          alignSelf="flex-start"
          borderBottomLeftRadius={'$radius.base'}
          borderBottomRightRadius={'$radius.base'}
          pr={getTokenValue('$space.sm') - letterSpacing.tags}
        >
          <PSText.Tags color={'$color.textWhite'}>AP</PSText.Tags>
        </XStack>
      )}
    </YStack>
  );
}
